var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "sub-head"
  }, [_c('div', {
    staticClass: "sub-visual",
    class: {
      'sub-visual--sub-tab': _vm.subTab
    }
  }, [_c('div', {
    staticClass: "sub-visual__inner"
  }, [_c('v-container', [_c('div', {
    staticClass: "sub-visual__tit-wrap"
  }, [_c('h2', {
    staticClass: "sub-visual__tit"
  }, [_vm._v(_vm._s(_vm.sh))])])])], 1), _c('div', {
    staticClass: "sub-visual__bg",
    style: 'background-image:url(' + _vm.bg + ');'
  })]), _vm.subTab ? _c('div', {
    staticClass: "sub-head__bottom"
  }, [_c('v-container', [_c('div', {
    staticClass: "sub-head__bottom__inner"
  }, [_c('v-row', {
    attrs: {
      "no-gutters": "",
      "align": "center"
    }
  }, [_c('v-col', {
    staticClass: "d-none d-md-block",
    attrs: {
      "cols": "auto"
    }
  }, [_c('div', {
    staticClass: "sub-index d-flex justify-center align-center px-20 px-xl-80"
  }, [_c('p', {
    staticClass: "font-weight-bold white--text"
  }, [_vm._v(_vm._s(_vm.index))]), _c('span', {
    staticClass: "d-inline-block mx-10 mx-lg-14"
  }, [_vm._v("l")]), _c('p', [_vm._v(_vm._s(_vm.total))])])]), _c('v-spacer', {
    staticClass: "d-none d-md-block"
  }), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "auto"
    }
  }, [_c('client-gnb', {
    attrs: {
      "className": "sub-tab-wrap",
      "tabActive": _vm.tabActive,
      "sh": _vm.sh
    }
  })], 1)], 1)], 1)])], 1) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }